import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../azureLogin/useAuth';
import 'bootstrap-icons/font/bootstrap-icons.css';
import EditModal from '../Models.js/EditModel';
import SFLink from '../azureLogin/SFLink';
import ServiceSelectorTrackerICD from './cServiceSelectorTrackerICD';
import ServiceSelectorTrackerCGFNS from './cServiceSelectorTrackerCGFNS';
import ProgReportSection from './cProgReportSection';
import { Form, Row, Col, Button, Modal,OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { FaTrash } from 'react-icons/fa';
import ConfirmPopupAddtRecptModel from '../Models.js/ConfirmPopupAddtRecptModel';
import MissingRequirementsModal from './cMissingRequirementsModal';

const formatDate = (isoString) => {
  const date = new Date(isoString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
};

const HomePage = ({isICD}) => {
  const { t, i18n } = useTranslation();
  const [myPurchasedOrders, setMyPurchasedOrders] = useState([null]);
  const [unPaidApps, setUnPaidApps] = useState([null]);
  const [unPaidAddtApps, setUnPaidAddtApps] = useState([null]);
  const [myOrders, setMyOrders] = useState(null);
  const [error, setError] = useState(null);
  const [applicantImage, setApplicantImage] = useState();
  const { token,fetchData,postData,request } = useAuth();
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [editModal, setEditModal] = useState(false);
  const [tempEmail, setTempEmail] = useState('');
  const [tempPhone, setTempPhone] = useState('');
  const [portal, setPortal] = useState('applicantPortal');
  const [PortalCode, setPortalCode] = useState('');
  const [userHasPaidApps, setUserHasPaidApps] = useState(false);
  const [userHasUnPaidApps, setUserHasUnPaidApps] = useState(false);
  const [userHasUnPaidAddtApps, setUserHasUnPaidAddtApps] = useState(false);
  const [globalBalanceAmount, setGlobalBalanceAmount] = useState(0);
  const [userHasACPROQuestionnaire, setUserHasACPROQuestionnaire] = useState(false);
  // const [userName , setUserName] = useState('');
  const [showProgReportSection, setShowProgReportSection] = useState(false);
  const [showRejectionTextDiv, setShowRejectionTextDiv] = useState(false);
  const [rejectionText, setRejectionText] = useState('');
  const [prsApp, setPRSApp] = useState();
  const [showMissingReqModal, setShowMissingReqModal] = useState(false);
  const [MissingReqAppId, setMissingReqAppId] = useState('');
  const [unConfirmedLicenseCount, setUnConfirmedLicenseCount] = useState([]);
  const [deleteAppId, setDeleteAppId] = useState('');

  const handleMissingReqShow = (appId) => {
   // debugger;
    setMissingReqAppId(appId);
    setShowMissingReqModal(true)

  };
  const handleMissingReqClose = () => setShowMissingReqModal(false);

  const handleClickPRSAccept = () => {
    // Handle accept logic
  };
  const handleClickPRSShowReason = () => {
    // Handle show reason logic
  };

  const handleClickPRSAcceptRejection = () => {
    // Handle accept rejection logic
  };

  


  useEffect(() => {
    if (myOrders) {
      setTempEmail(myOrders.Email);
      setTempPhone(myOrders.Phone);
    }
  }, [myOrders]);

  // Function to handle upload
  const handleFileChange = (event) => {
    handleUpload(event.target.files[0]); // Automatically trigger upload when a file is selected
  };

  const handleUpload = async (file) => {
    if (!file) {
      console.log("No file selected");
      return;
    }

    setUploading(true);

    let formData = new FormData();
    formData.append('file', file);

    try {
      const response = await postData('/Contact/me/photo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Upload successful:', response);

      // Update state with new image URL if needed
      // Assuming the server returns a new image URL in response?.data.imageUrl
      setApplicantImage(URL.createObjectURL(file));

    } catch (error) {
      console.log('Error uploading file:', error);
    } finally {
      setUploading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  }
  //

  useEffect(() => {
    const fetchImage = async () => {
    

      let config = {
        method: 'get',
        maxBodyLength: Infinity,       
        headers: {
          'accept': 'application/octet-stream',
          'Authorization': `Bearer ${token}`
        },
        responseType: 'blob'
      };

      try {
        const response = await fetchData('/Contact/me/photo',config);
        const imageUrl = URL.createObjectURL(response?.data);
        setApplicantImage(imageUrl);
      } catch (error) {
        console.log('Error fetching image:', error);
      }
    };

    fetchImage();
  }, [token]);

  //Global Balanace
  useEffect(() => {
    const fetchGB = async () => {
     
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        const response = await fetchData('/Contact/me/GlobalBalance?fields=Amount__c%2CContact__c%2CId%2CName',config);;
        const gb= response?.data;
        console.log('Global Balance');
        setGlobalBalanceAmount(gb ? gb.Amount__c : 0);
         
      } catch (error) {
        console.log('Error fetching GB:', error);
      }
    };
    fetchGB();
  }, [token]);

  //fetch unconfirmed Licenses
  useEffect(() => {
    const fetchUNConfLic = async () => {
     

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        const response = await fetchData('/Contact/me/LicenseRegistration?confirmed=false&fields=Id',config);
   
        console.log('fetch unconfirmed Licenses');        
        console.log(response?.data);
        setUnConfirmedLicenseCount(response?.data);
         
      } catch (error) {
        console.log('Error fetching unconfirmed Licenses:', error);
      }
    };
    fetchUNConfLic();
  }, [token]);

//
  //userHasACPROQuestionnaire
  useEffect(() => {
    const fetchHasACPROQuestionnaire = async () => {
      

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        const response = await fetchData('/Contact/me/Questionnaire?fields=Id',config);
        
        console.log('fetchHasACPROQuestionnaire');
        setUserHasACPROQuestionnaire(response?.data?.length> 0);
        console.log(userHasACPROQuestionnaire); 
      } catch (error) {
        console.log('Error fetching image:', error);
      }
    };
    fetchHasACPROQuestionnaire();
  }, [token, userHasACPROQuestionnaire]);

//END:userHasACPROQuestionnaire


  useEffect(() => {
    const fetchContact = async () => {
      

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      };

      try {
// debugger;
        const urlPath='/Contact/me?fields=Id%2CAccountId%2CApplicant_ID__c%2CEmail%2CPhone%2CFirstName%2CAvailableApplications.Id%2CAvailableApplications.Name%2CAvailableApplications.Program_Name__c%2CAvailableApplications.Price__c%2CAvailableApplications.URLFormAssemblyID__c%2CAvailableApplications.Complete_Percentage__c%2CAvailableApplications.MakeApplicationAvailableManually__c%2CAvailableApplications.EducationRequirementHelpText__c%2CAvailableApplications.Additional_Services_Order__c%2CAvailableApplications.Add_on_count__c%2CAvailableApplications.Additional_Order_Count__c%2CAvailableApplications.Add_on_count_un_paid__c%2CAvailableApplications.Additional_Order_Un_Paid__c%2CAvailableApplications.Total_Additional_Recipients__c%2CAvailableApplications.Total_Expedited_Service__c%2CAvailableApplications.Total_Express_Mail_Service__c%2CAvailableApplications.ParentApplication__c%2CAvailableApplications.Application_Expired__c%2CAvailableApplications.Additional_Recipient_Order__c%2CAvailableApplications.Re_Evaluation_Order__c%2CAvailableApplications.WorkRequirementHelpText__c%2CAvailableApplications.LicenseRequirementHelpText__c%2CAvailableApplications.IDRequirementHelpText__c%2CAvailableApplications.Update_EduHis_for_Eligibility__c%2CAvailableApplications.Update_ID_for_Eligibility__c%2CAvailableApplications.Program_Report_Recipient__c%2CAvailableApplications.Update_WH_for_Eligibility__c%2CAvailableApplications.UpdateLicensesforEligibility__c%2CAvailableApplications.Contact__c%2CAvailableApplications.is_Payment_Made__c%2CAvailableApplications.PaymentReceived__c%2CAvailableApplications.Chargent_Order__c%2CAvailableApplications.Description__c%2CAvailableApplications.RuleCode__c%2CAvailableApplications.isICDApplication__c%2CAvailableApplications.application_expiration_date__c%2CAvailableApplications.Internal_Status__c%2CAvailableApplications.order_Payment_Date__c%2CAvailableApplications.External_Status__c%2CAvailableApplications.Additional_Recipient_Needed__c%2CAvailableApplications.ICD_Program_Recipient_Edit_Ability__c%2CAvailableApplications.Program_Report_Link__c%2CAvailableApplications.Badge_Link__c%2CAvailableApplications.Re_Evaluation_Needed__c%2CAvailableApplications.PortalCode__c%2CAvailableApplications.Unpaid_App__c%2CAvailableApplications.Complete_Percentage__c%2CAvailableApplications.isProfileDataFilled__c%2CAvailableApplications.Report_Acceptance__c%2CAvailableApplications.Questionnaire_Needed__c%2CAvailableApplications.Questionnaire_Obtained__c%2CAvailableApplications.isICDAppReadyToApply__c%2CAvailableApplications.Update_Specialty_for_Eligibility__c%2CAvailableApplications.Specialty_Certification_Help_Text__c%2CAvailableApplications.Portfolio_Help_Text__c%2CAvailableApplications.Update_Portfolio_for_Eligibility__c%2CAvailableApplications.Update_ELP_for_Eligibility__c%2CAvailableApplications.Update_Cont_Edu_for_Eligibility__c%2CAvailableApplications.Continuing_Education_Help_Text__c%2CAvailableApplications.isICDRecipientFilled__c%2CAvailableApplications.HasICDQuestionnaire__c';
        
        setPortal(isICD===true ? 'icd':'applicantPortal');
        setPortalCode(isICD===true ? 'ICD':'CGFNS-AP');

        const response = await fetchData(urlPath,config);
        const resdata = response?.data;
        console.log(resdata);

        setMyOrders(resdata);
        // setUserName(resdata.FirstName);
        // debugger;

        const avialbleOrders= resdata?.AvailableApplications?.filter(order =>
          order.Internal_Status__c !== 'Expired' && order.Internal_Status__c !== 'Unsubmitted - Order Deleted');

        const filteredUnpaidApps = isICD ? (avialbleOrders?.filter(order =>
          order.Unpaid_App__c === true && order.PortalCode__c === 'ICD' && order.RuleCode__c )) : (resdata?.AvailableApplications?.filter(order =>
            order.Unpaid_App__c === true && order.PortalCode__c !== 'ICD' && order.RuleCode__c) );
        
        filteredUnpaidApps?.sort((a, b) => {
          if (a.Complete_Percentage__c === null) return 1;
          if (b.Complete_Percentage__c === null) return -1;
          return b.Complete_Percentage__c - a.Complete_Percentage__c;
        });
        setUnPaidApps(filteredUnpaidApps);


        const filteredOrders =  isICD ? (avialbleOrders?.filter(order =>
          order.Chargent_Order__c != null && order.PortalCode__c === 'ICD'
        )):(resdata?.AvailableApplications?.filter(order =>
          order.Chargent_Order__c != null && order.PortalCode__c !== 'ICD'
        ));

        filteredOrders?.sort((a, b) => {
          if (a.Complete_Percentage__c === null) return 1;
          if (b.Complete_Percentage__c === null) return -1;
          return b.Complete_Percentage__c - a.Complete_Percentage__c;
        });

        setMyPurchasedOrders(filteredOrders);
        
        const unPaidAddtApps =  isICD ? (avialbleOrders?.filter(order =>
          order.Unpaid_App__c === true && order.PortalCode__c === 'ICD' && order.RuleCode__c ==='')) : (resdata?.AvailableApplications?.filter(order =>
            order.Unpaid_App__c === true && order.PortalCode__c !== 'ICD' && order.RuleCode__c==='') );
        setUnPaidAddtApps(unPaidAddtApps);

        setUserHasPaidApps(filteredOrders?.length > 0);
        setUserHasUnPaidApps(unPaidApps?.length > 0);
        setUserHasUnPaidAddtApps(unPaidAddtApps?.length > 0);

      } catch (error) {
        setError(error);
      }
    };

    fetchContact();
  }, [isICD, token, unPaidApps?.length]);


  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!myOrders) {
    return <div>Loading...</div>;
  }

  // to edit and save Email and phone
  const handleEditToggle = () => {
    setEditModal(true);
  };

  const handleSave = async () => {
    const updatedData = { Email: tempEmail, Phone: tempPhone };

    const config = {
      method: 'patch',
      maxBodyLength: Infinity,
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
      },
      data: updatedData,
    };

    try {
      const response = await request('/Contact/me',config);
      console.log(JSON.stringify(response?.data));
      setMyOrders({ ...myOrders, ...updatedData }); // Update local state with the new data
      setEditModal(false);
    } catch (error) {
      console.log(error);
    }
  };
  
  // additional information

  const AdditionalInfoColumn = ({ app }) => {
    return (
      <div>
        {app.RuleCode__c === 'ACPRO' && (
          <div>
            {`${t('Additional_Directions_Message')}`}
            <a
              href="https://trudiligence.bgsecured.com/c/p/unsolicited_portal?guid=ceSI6fzzxqJ3Md6ZaDIoDeay6cm4zlr2"
              target="_blank"
              rel="noopener noreferrer"
            >
            </a>
          </div>
        )}

        {(app.RuleCode__c === 'NCNZ1' ||
          app.RuleCode__c === 'AONL' ||
          app.RuleCode__c === 'CGNC-ICN' ||
          app.RuleCode__c === 'BCEN' ||
          app.RuleCode__c === null) && (
            <div>{`${t('No_additional_directions')}`}</div>
          )}

        {app.isICDApplication__c && app.RuleCode__c !== 'ICDCEAT' && (
          <div>{`${t('ICD_Additional_Information')}`}</div>
        )}

        {app.RuleCode__c === 'ICDCEAT' && (
          <div>n/a</div>
        )}
      </div>
    );
  };
  //Order Coulumn

  const OrderColumn = ({ app}) => {
    const { t } = useTranslation();
    const [showConfirmPopupAddtRecpt, setShowConfirmPopupAddtRecpt] = useState(false);
    
      
    const handleCloseConfirmPopupAddtRecpt = () => setShowConfirmPopupAddtRecpt(false);
    const handleConfirmPopupAddtRecpt = () => {
      // Add your logic for confirming the purchase here
      setShowConfirmPopupAddtRecpt(false);
    };

    return (
      <div>
        {app.Program_Name__c}
        {app.Program_Name__c && (
          <p className="text-primary fst-italic">({app.Name})</p>
        )}

        {app.Program_Report_Link__c && app.External_Status__c !== 'Expired' && app.External_Status__c !== 'Report Issued: Not Accepted by Applicant' && (
          <div >          
            <SFLink path={`/${portal}/s/?action=setShowProgramReport&recId=${app.Id}`} >{t('View_Program_Report')}</SFLink>      
          </div>
        )}

        {app.Badge_Link__c && app.External_Status__c !== 'Expired' && app.External_Status__c === 'Certified' && (
          <div>
            <SFLink path={`/${portal}/s/?action=setShowBadgelink&recId=${app.Id}`} >{t('View_Badge')}</SFLink>                
          </div>
        )}

        {app.ICD_Program_Recipient_Edit_Ability__c && (
          <div>
            {t('to_view_edit_icd_questionnaire')}
            <SFLink path={`/${portal}/s/?action=navigateToIcdQuestionnaire&recId=${app.Id}`} variant="a">
            &nbsp;{t('here')}</SFLink>
             
          </div>
        )}

        {app.RuleCode__c === 'ACPRO' &&
          ['Waiting for Documents', 'Documentation Ready for Evaluation', 'In Application Review'].includes(app.External_Status__c) && userHasACPROQuestionnaire && (
            <div>
              {t('to_view_edit_acpro_questionnaire')}
              <SFLink path={`/${portal}/s/acpro-pre-pay-questionnaire`} variant="a">
              &nbsp;{t('here')}</SFLink>
            </div>
          )
        }

        {(app.Additional_Recipient_Needed__c && !app.Application_Expired__c && !app.Additional_Recipient_Order__c) &&
          ['Waiting for Documents', 'Documentation Ready for Evaluation', 'All Documents Approved'].includes(app.External_Status__c) && (
            <div>
              <SFLink path={`/${portal}/s/?action=handleAdditionalRecipient&recId=${app.Id}`} className="btn btn-primary ml-2 mt-2">{t('Add_Additional_Recipient')}</SFLink>      
               
              <ConfirmPopupAddtRecptModel show={showConfirmPopupAddtRecpt}  handleClose={handleCloseConfirmPopupAddtRecpt}  handleConfirm={handleConfirmPopupAddtRecpt} 
      />
            </div>
          )
        }

        {(['ICDPT', 'ICDPTCE'].includes(app.RuleCode__c) && !app.Application_Expired__c) &&
          !['ACPRO', 'ICDNCCAOM'].includes(app.RuleCode__c) &&
          app.External_Status__c !== 'Report Issued to Recipient' && (
            <div>             
              <SFLink path={`/${portal}/s/?action=handlePTQuestionnaire&recId=${app.Id}`} variant="a"  className="btn btn-primary ml-2 mt-2">
              {t('View_Edit_PT_Questionnaire')} </SFLink>
            </div>
          )
        }

        {app.RuleCode__c &&
          (app.Add_on_count_un_paid__c > 0 || app.Additional_Order_Un_Paid__c > 0) &&
          ['Waiting for Documents', 'Documentation Ready for Evaluation', 'All Documents Approved'].includes(app.External_Status__c) && (
            <div>
              <SFLink path={`/${portal}/s/?action=setShowAdditionalPopUp&recId=${app.Id}`} className="btn btn-primary ml-2 mt-2">{t('to_view_Additional_Services')}</SFLink>      
             
            </div>
          )
        }

        {app.Re_Evaluation_Needed__c && !app.Application_Expired__c && !app.Re_Evaluation_Order__c && app.External_Status__c === 'Report Issued to Recipient' && (
          <div>
            <SFLink path={`/${portal}/s/?action=handlePurchaseReEvaluation&recId=${app.Id}`} className="btn btn-primary ml-2 mt-2">{t('Purchase_Re_Evaluation')}</SFLink>      
             
          </div>
        )}        
      </div>
    );
  };

 
  const AppStatusTracker = ({ app, isICDPortal }) => {
    const { t } = useTranslation();

    return (
      <>
        {app.External_Status__c === 'Refund Request in Progress' && (
          <div>{t('request_to_cancel')}</div>
        )}
        {app.External_Status__c === 'Cancelled-Refunded' && (
          <div>{t('order_canceled_approved_refund')}</div>
        )}
        {app.External_Status__c === 'In Application Review' && (
          <div>{t('app_still_in_review')}</div>
        )}
        {app.External_Status__c === 'Expired' && (
          <div>{t('app_expired')}</div>
        )}
        {app.External_Status__c === 'Report Issued: Not Accepted by Applicant' && (
          <div>{t('app_not_accepted_by_applicant')}</div>
        )}
        {app.External_Status__c === 'Application Acceptance Pending' && (
          <div>{t('app_still_in_review')}</div>
        )}
        {app.External_Status__c === 'Application Not Accepted' && (
          <>
            {isICDPortal ? (
              <div>{t('app_not_accepted_icd')}</div>
            ) : (
              <div>{t('app_not_accepted')}</div>
            )}
          </>
        )}
        {app.External_Status__c === 'In Progress' && (
          <div>{t('translation_in_progress')}</div>
        )}
        {app.External_Status__c === 'Appeal in Review' && (
          <div>{t('Appeal_in_Review')}</div>
        )}
        {app.External_Status__c === 'Appeal Denied' && (
          <div>{t('Appeal_Denied')}</div>
        )}
        {app.External_Status__c === 'Appeal Granted' && (
          <div>{t('Appeal_Granted')}</div>
        )}
        {app.External_Status__c === 'Completed' && (
          <div>{t('translation_completed')}</div>
        )}
        {app.External_Status__c === 'On-Hold: Charge Back' && (
          <div>{t('On_Hold_Charge_Back')}</div>
        )}
        {app.External_Status__c === 'In Review with Consultant' && (
          <>
            <Link to={`/${isICD?'icd':'cgfns'}/statustracker?applicationID=${app.Id}&ExtStatus=${app.External_Status__c}`} className="btn btn-primary ml-2">{t('View_order_req')}</Link>

            <br />
            <br />
            <div>
              <b>{t('In_Review_with_Consultant')}</b>
            </div>
          </>
        )}
        {app.External_Status__c === 'In Review with Analyst' && (
          <>
            <Link to={`/${isICD?'icd':'cgfns'}/statustracker?applicationID=${app.Id}&ExtStatus=${app.External_Status__c}`} className="btn btn-primary ml-2">{t('View_order_req')}</Link>

            <br />
            <br />
            <div>
              <b>{t('In_Review_with_Analyst')}</b>
            </div>
          </>
        )}
        {app.External_Status__c === 'Certified' && (
          <div>{t('Certified')}</div>
        )}
        {app.External_Status__c === 'Cancelled' && (
          <div>{t('Cancelled')}</div>
        )}
        {app.External_Status__c === 'Report Pending Applicant Approval' && (
          <>
            {app.RuleCode__c === 'NCNZ1' && (
              <div>
                <p>{t('Your CVS-NCNZ report has been created for your review and approval. Click View Report to download and review your report.')}</p>
                <p>{t('If you approve your report, select Approve and Send and it will be transmitted to the Nursing Council of New Zealand.')}</p>
                <p>{t('If your report requires any correction, select Request a correction to tell us what you feel should be corrected.')}</p>
                <p>{t('You have 30 days from the date your report was made available to you to Approve and Send your report or Request a Correction. If no action is taken within 30 days, your CVS-NCNZ order will automatically expire.')}</p>
              </div>
            )}
          </>
        )}
        {app.External_Status__c === 'Report in Queue for Recipient' && (
          <div>{t('approved_report_in_queue')}</div>
        )}
        {app.External_Status__c === 'Report Issued to Recipient' && (
          <>
            {app.RuleCode__c === 'NCNZ1' && (
              <div>{t('Report_issued_to_recipient_NCNZ')}</div>
            )}
            <div>{t('Report_issued_to_recipient')}</div>
          </>
        )}
        {[
          'Waiting for Documents',
          'Report Rejected by Applicant',
          'All Documents Approved',
          'Documentation Ready for Evaluation'
        ].includes(app.External_Status__c) && (

            <Link to={`/${isICD?'icd':'cgfns'}/statustracker?applicationID=${app.Id}&ExtStatus=${app.External_Status__c}`} className="btn btn-primary ml-2">{t('View_order_req')}</Link>
          )}
      </>
    );
  };

  //END 

  //SERVICE STATUS TRACKER

  const ServiceSelectorComponent = ({
    isICDPortal,
    requiredInfo,
    navigateToQuestionnaire,
    navigateToMyProfile,
    handleApplicationDeleteOnConfirm,   
    goToShoppingCart,
    showDoneButton,
    updateSelectedApp,
    checkedUnpaidApps,
    closeDelConfirmPopup, 
    showAppDeleteMessage
     
  }) => {
// debugger;
setPortal(isICD===true ? 'icd':'applicantPortal');
setPortalCode(isICD===true ? 'ICD':'CGFNS-AP');
    const apps = myOrders?.AvailableApplications?.filter(order =>
      order.Internal_Status__c !== 'Expired' && order.Internal_Status__c !== 'Unsubmitted - Order Deleted');

    const unpaidAppCount = unPaidApps ? unPaidApps.length : 0;
    const unpaidAddtAppCount =unPaidAddtApps? unPaidAddtApps.length :0;
    const hasUnPaidApps =unPaidApps?.length >0;
    const hasPaidApps= myPurchasedOrders?.length>0;
    const [showRequiredInfoPopUp, setShowRequiredInfoPopUp] = useState(false);
    const [showDelConfirmPopup, setShowDelConfirmPopup] = useState(false);
    const [showModal, setShowModal] = useState(false);
   


    const populateShowDelConfirmPopup = (appId) => {
     // debugger;
      setDeleteAppId(appId);
      setShowDelConfirmPopup(true);
      
    };
  
     // Method to close the modal
  const closeRequiredinfoModel = () => {
    setShowRequiredInfoPopUp(false);
  };
  const closeShowDelConfirmPopup = () => {
    setShowDelConfirmPopup(false);
  };


    const openModalWithReqInfo = () => {
        setShowModal(true);
    };

    const closeModel = () => {
        setShowModal(false);
    };
    


  const showDeleteMessage = () => {
      // Show delete message
  };

  const hideDeleteMessage = () => {
      // Hide delete message
  };  


    return (
      <div>        
        {!hasUnPaidApps && !hasPaidApps && (
          <>
            <div className="text-center" >
            {t('Service_Selector_Head_Text')}
            </div>
            <br />
            <div>
              {isICDPortal ? (
                <ServiceSelectorTrackerICD tabToHighlight="1" isICDPortal={isICDPortal} />
              ) : (
                <ServiceSelectorTrackerCGFNS tabToHighlight="1" isICDPortal={isICDPortal} />
              )}
              <p>
                {t('Select_your_purpose_1')} <SFLink path={`/${portal}/s/?action=goToServiceSelector`}  variant="a"  className="btn btn-outline-primary btn-sm">
                Service Selector </SFLink> {t('Select_your_purpose_2')}
                </p>
            </div>
          </>
        )}
  
        <Modal show={showRequiredInfoPopUp} onHide={closeRequiredinfoModel}>
          <Modal.Header closeButton>
            <Modal.Title>{t('App_required_info')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {requiredInfo && !requiredInfo.is_ACPRO_Questionnaire_filled__c && (
              <p>
                {t('Questionnaire_text')}&nbsp;
                <button className='anchor-button' onClick={navigateToQuestionnaire}>{t('here')}</button>
                
              </p>
            )}
            {requiredInfo && !requiredInfo.is_required_information_filled__c && (
              <p>
                {t('App_required_info')}&nbsp;
                <button className='anchor-button' onClick={navigateToMyProfile}>{t('here')}</button>
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeRequiredinfoModel}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
  
        <Modal show={showDelConfirmPopup} handleClose={() => setShowDelConfirmPopup(false)}>
          <Modal.Header >
            <Modal.Title>Please Confirm!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t('confirm_application_delete')}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeShowDelConfirmPopup}>
              Cancel
            </Button>
            <SFLink variant="button" className="btn btn-danger" path={`/${portal}/s/?applicationId=${deleteAppId}&action=handleApplicationDeleteOnConfirm&recId=${deleteAppId}`} >           
              &nbsp;Yes&nbsp;
              </SFLink>
          </Modal.Footer>
        </Modal>        
        {apps && apps?.length>0 && ( 
          <div className="slds-m-around_x-large">
            {isICDPortal ? null : (
              <p>
                {t('Applicant_Portal_Instructions_user_profile_info')}
              </p>
            )}
  
            <div>              
              {unPaidApps && unPaidApps?.length > 0 && isICDPortal ? (
                     <div className="row mb-3">
                     <div className="col-12">
                       <div className="d-flex justify-content-between align-items-center heading-box">
                         <h2 className="heading">{t('Available_Applications_Service_Selector')}</h2>
                         <h2 className="heading account-balance">{t('Account_Balance')}: ${globalBalanceAmount}</h2>
                       </div>
                     </div>
                   </div>
                  ) : (
                    <div className="row mb-3">
                     <div className="col-12">
                       <div className="d-flex justify-content-between align-items-center heading-box">
                         <h2 className="heading">{t('Available_Applications_user_profile_info')}</h2>
                         <h2 className="heading account-balance">{t('Account_Balance')}: ${globalBalanceAmount}</h2>
                       </div>
                     </div>
                   </div>
                  )}
                 
               {!hasUnPaidApps && hasPaidApps && (
                <>
                  <div>
                    {isICDPortal ? (
                      <ServiceSelectorTrackerICD tabToHighlight="1" isICDPortal={isICDPortal} />
                    ) : (
                      <ServiceSelectorTrackerCGFNS tabToHighlight="1" isICDPortal={isICDPortal} />
                    )}
                    <p>
                      {t('Select_your_purpose_1')} <SFLink path={`/${portal}/s/?action=goToServiceSelector`} variant="a"  className="btn btn-outline-primary btn-sm">
                      Service Selector </SFLink> {t('Select_your_purpose_2')}
                      </p>
                  </div>
                </>
              )}
              {unpaidAppCount >= 2 && !isICDPortal && (
                <>
                   <p>
                    There are currently two applications in progress. Please select one to proceed.
                  </p>
                  {unPaidApps.map(app => (
                  <React.Fragment key={app.Id}>
                    {(app.Unpaid_App__c === '' && app.ParentApplication__c === '') && (
                      <>
                        <div style={{ marginTop: '1rem', marginBottom: '0.5rem', padding: '0rem 1rem' }}>
                          {/* Placeholder for ServiceSelectorTracker */}
                        </div>
                        <Row style={{ padding: '1rem 2rem' }}>
                          <Col xs={1}>
                            <Form.Check 
                              type="checkbox" 
                              id={app.Id} 
                              onChange={() => checkedUnpaidApps(app.Id)} 
                            />
                          </Col>
                          <Col xs={8}>
                            <p>
                              <b>Name:</b> <br /> {app.Program_Name__c}
                            </p>
                          </Col>
                          <Col xs={3}>
                            <p>
                              <b>Price:</b> <br /> ${app.Price__c}
                            </p>
                          </Col>
                        </Row>
                      </>
                    )}
                  </React.Fragment>
                ))}
                <div style={{ padding: '0.5em' }}>
                {showDoneButton && (
                  <div className="clearfix">
                    <div className="float-right">
                      <Button variant="outline-primary" onClick={updateSelectedApp}>
                        Proceed
                      </Button>
                    </div>
                  </div>
                )}
              </div>
                </>
              )
              }
              {unpaidAppCount === 1 && (
                <>
                  {unPaidApps.map(app => (
                    <div key={app.Id} >
                      { app.Unpaid_App__c && app.RuleCode__c && (<>
                      {isICDPortal ? (
                        <ServiceSelectorTrackerICD
                          currentApp={app}
                          tabToHighlight="1"
                          isICDPortal={isICDPortal}
                          acproQuestionnaireFilled={userHasACPROQuestionnaire}
                        />
                      ) : (
                        <ServiceSelectorTrackerCGFNS
                          currentApp={app}
                          tabToHighlight="1"
                          isICDPortal={isICDPortal}
                        />
                      )}
                      <div className="container" style={{ padding: '1rem 2rem' }}>
                      <div className="row">
                          <div className="col-md-5">
                              <p>
                                  <b>{`${t("Name_user_profile_info")}`}</b>: <br />
                                  {app.Program_Name__c !== 'Credential Verification Service-Nursing Council of New Zealand - Reactivation Order' &&
                                  app.Program_Name__c !== 'Credential Evaluation Service-Board of Certification of Emergency Nursing - Reactivation Order' &&
                                  app.Program_Name__c !== 'Credentials Evaluation for ACPRO - Reactivation Order' && (
                                      <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip>{`${t("app_deletion_help_text")}`}</Tooltip>}
                                      >
                                      <SFLink variant="button" className="btn" path={`/${portal}/s/?action=handleApplicationDelete&recId=${app.Id}`} >
                                      <FaTrash  
                                              className="text-danger"
                                              onMouseEnter={showDeleteMessage}
                                              onMouseLeave={hideDeleteMessage}                                              
                                          />
                                      </SFLink>
                                          
                                      </OverlayTrigger>
                                  )}
                                  {app.Program_Name__c} <br />
                                  {showAppDeleteMessage && (
                                      <small style={{ color: 'red' }}>{`${t("app_deletion_help_text")}`}</small>
                                  )}
                              </p>
                          </div>
                          <div className="col-md-3">
                              <p>
                                  <b>{`${t("Price_user_profile_info")}`}</b>: <br />${app.Price__c}
                              </p>
                          </div>
                          <div className="col-md-4">
                              <b>To Do:</b>
                              {isICDPortal ? (
                                  <>
                                      {(app.RuleCode__c === 'ICDPTCE' || app.RuleCode__c === 'ICDPTA') && (
                                          <>
                                              {(app.isICDAppReadyToApply__c && app.isPTQuestionnaireFilled__c && app.isProfileDataFilled__c) ||
                                              (app.isICDAppReadyToApply__c && app.isICDRecipientFilled__c && app.isProfileDataFilled__c) ||                                              
                                              (!(app.RuleCode__c === 'ACPRO' && userHasACPROQuestionnaire && app.isProfileDataFilled__c)) ? (
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=goToShoppingCart&recId=${app.Id}`} > {`${t("Apply_user_profile_info")}`} </SFLink>
                                              ) : (
                                                  app.RuleCode__c === 'ACPRO' && !userHasACPROQuestionnaire && app.isProfileDataFilled__c && (
                                                      <>
                                                          {`${t("Questionnaire_text")}`}&nbsp;
                                                          <SFLink  variant="a" path={`/${portal}/s/?action=navigateToQuestionnaire&recId=${app.Id}`}  > {`${t("here")}`} </SFLink>
                                                      </>
                                                  )
                                              )}
                                          </>
                                      )}
                                      {(app.RuleCode__c === 'ICDNCCAOM' && app.isProfileDataFilled__c) && (
                                        <SFLink  variant="a" path={`/${portal}/s/?action=goToShoppingCart&recId=${app.Id}`} > {`${t("Apply_user_profile_info")}`} </SFLink>
                                      )}
                                      {((app.RuleCode__c === 'ACPRO' && userHasACPROQuestionnaire && app.isProfileDataFilled__c)) ? (
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=goToShoppingCart&recId=${app.Id}`} > {`${t("Apply_user_profile_info")}`} </SFLink>
                                              ) : (
                                                  app.RuleCode__c === 'ACPRO' && !userHasACPROQuestionnaire && app.isProfileDataFilled__c && (
                                                      <>
                                                          {`${t("Questionnaire_text")}`}&nbsp;
                                                          <SFLink  variant="a" path={`/${portal}/s/?action=navigateToQuestionnaire&recId=${app.Id}`}  > {`${t("here")}`} </SFLink>
                                                      </>
                                                  )
                                              )
                                      }
                                      {(app.RuleCode__c === 'ICDPTCE' || app.RuleCode__c === 'ICDPTA') && (
                                          (app.hasPTQuestionnaire__c && !app.isPTQuestionnaireFilled__c && app.isProfileDataFilled__c) && (
                                              <>
                                                  {`${t("Questionnaire_text")}`}&nbsp;
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=navigateToPTQuestionnaire&recId=${app.Id}`} > {`${t("here")}`} </SFLink>
                                              </>
                                          )
                                      )}
                                      {!app.isICDRecipientFilled__c && !app.isICDAppReadyToApply__c && app.isProfileDataFilled__c && (
                                          app.HasICDQuestionnaire__c && (
                                              <>
                                                  <p><span>&#9432;</span>{`${t("recipient_info_text_label")}`}</p>
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=navigateToRecipientQuestionnaire&recId=${app.Id}`} > {`${t("add_recipient_information")}`} </SFLink>                                                  
                                              </>
                                          )
                                      )}
                                      {app.isProfileDataFilled__c === false && app.isICDAppReadyToApply__c === false && (
                                          <>
                                              <button className='anchor-button' style={{ color: 'red' }} onClick={openModalWithReqInfo}>
                                                  <span>&#9432;</span>{`${t("missing_required_info")}`}
                                              </button>
                                              <p>
                                                  {`${t("click_my_profile_to_complete")}`}&nbsp;
                                                  <SFLink variant="a" path={`/${portal}/s/?action=navigateToMyProfile&recId=${app.Id}`} > {`${t("My_Profile_tabs")}`} </SFLink>
                                              </p>
                                          </>
                                      )}
                                  </>
                              ) : (
                                  <>
                                      {app.isProfileDataFilled__c && app.Questionnaire_Obtained__c === app.Questionnaire_Needed__c ? (
                                          <SFLink  variant="a" path={`/${portal}/s/?action=goToShoppingCart&recId=${app.Id}`} > {`${t("Apply_user_profile_info")}`} </SFLink>
                                              
                                          
                                      ) : (
                                          unConfirmedLicenseCount > 0 && (
                                                 <>
                                                  You must confirm any licenses listed as unconfirmed on the License Confirmation section of your
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=goTOMyProfileUnconfirmed&recId=${app.Id}`}  > {`${t("My_Profile_tabs")}`} </SFLink>
                                                  before you are able to pay and complete your order.
                                              </>
                                          )
                                      )}
                                      {app.isProfileDataFilled__c === false && app.isICDAppReadyToApply__c === false && (
                                          <>
                                              <button className='anchor-button' onClick={openModalWithReqInfo}>
                                                  <span>&#9432;</span>{`${t("missing_required_info")}`}
                                              </button>
                                              <p>
                                                  {`${t("click_my_profile_to_complete")}`}&nbsp;
                                                  <SFLink  variant="a" path={`/${portal}/s/?action=navigateToMyProfile&recId=${app.Id}`} > {`${t("My_Profile_tabs")}`} </SFLink>
                                                  
                                              </p>
                                          </>
                                      )}
                                  </>
                              )}
                          </div>
                      </div>
          
                      <Modal show={showModal} onHide={closeModel}>
                          <Modal.Header closeButton>
                              <Modal.Title className='w-100 text-center'>{`${t("required_info")}`}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                              {!app.Update_ID_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("update_id_doc")}`}</u></h1>
                                      <div className="help-text">{app.IDRequirementHelpText__c}</div>
                                      <br />
                                  </>
                              )}
                              {!app.Update_EduHis_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("update_education_history")}`}</u></h1>
                                      <div className="help-text">{app.EducationRequirementHelpText__c}</div>
                                      <br />
                                  </>
                              )}
                              {!app.Update_WH_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("update_employment_history")}`}</u></h1>
                                      <div className="help-text">{app.WorkRequirementHelpText__c}</div>
                                      <br />
                                  </>
                              )}
                              {!app.UpdateLicensesforEligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("update_lic_and_reg")}`}</u></h1>
                                      <div className="help-text">{app.LicenseRequirementHelpText__c}</div>
                                      <br />
                                  </>
                              )}
                              {!app.Update_Specialty_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("Update_Specialty_Certification")}`}</u></h1>
                                      <div className="help-text">{app.Specialty_Certification_Help_Text__c}</div>
                                      <br />
                                  </>
                              )}
                              
                              {!app.Update_Cont_Edu_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("Update_Cont_Educ")}`}</u></h1>
                                      <div className="help-text">{app.Continuing_Education_Help_Text__c}</div>
                                      <br />
                                  </>
                              )}
                              {!app.Update_ELP_for_Eligibility__c && (
                                  <>
                                      <h1 className="heading"><u>{`${t("Update_ELP_for_Eligibility")}`}</u></h1>
                                      <div className="help-text">{`${t("Language_Proficiency_Required_Text")}`}</div>
                                      <br />
                                  </>
                              )}
                              {!app.Update_Portfolio_for_Eligibility__c && app.RuleCode__c ==='CGNC-ICN' &&  (
                                  <>
                                      <h1 className="heading"><u>{`${t("Update_portfolio_for_eligibility")}`}</u></h1>
                                      <div className="help-text">{app.Portfolio_Help_Text__c}</div>
                                      <br />
                                  </>
                              )}
                          </Modal.Body>
                          <Modal.Footer>
                              <Button variant="secondary" onClick={closeModel}>
                                  {`${t("Cancel")}`}
                              </Button>
                          </Modal.Footer>
                      </Modal>
                  </div>  
                  </>
                    )}
                    </div>
                  ))}
                </>
              )}
  
              <div className="row mb-4">
                <div className="col-12">
                  <h2 className="heading1">{t('Additional_Services')}</h2>
                </div>
              </div>
              {unpaidAddtAppCount >= 1 && unPaidApps.map(app => (
                <div key={app.Id} style={{ marginTop: '1rem', marginBottom: '0.5rem', padding: '0rem 1rem' }}>
                  <div className="slds-grid slds-gutters" style={{ padding: '1rem 2rem' }}>
                    <div className="slds-col slds-size_8-of-12">
                      <p>
                        <b>{t('Name_user_profile_info')}</b> : <br />
                        {app.Program_Name__c}
                      </p>
                    </div>
                    <div className="slds-col slds-size_3-of-12">
                      <p>
                        <b>{t('Price_user_profile_info')}</b> : <br />
                        ${app.Price__c}
                      </p>
                    </div>
                    <div className="slds-col slds-size_1-of-12">
                      <Button variant="outline-primary" id={app.Id} name={app.RuleCode__c} onClick={goToShoppingCart}>
                      {t('Apply_user_profile_info')}
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
              {unpaidAddtAppCount === 0 && (
                <p className='strong-red'>{t('No_Additional_Services')}</p>
              )}
            </div>
          </div>
        )}

        {(!apps || apps?.length===0) && (<>
          <p> {t('Available_Applications_user_profile_info')}</p>
          <p className='strong-red'>
          {t('No_available_apps')}
        </p></>
         ) }
      </div>
    );
  };

  //END : SERVICE STATUS TRACKER

 
  // view to button to change language function
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };


  return (
    <>
    <AuthenticatedTemplate>
        {isICD===true && (<button onClick={toggleLanguage} className='language-button'>
          {i18n.language === 'en' ? t('view in Français') : t('view in English')}
        </button>)}
        <div className='container-custom-color-cgfns p-2'>       
         
          <div className="row mb-3">
          
            <div className="col-lg-8 order-2 order-lg-1">
            <ServiceSelectorComponent 
              isICDPortal= {isICD}
         /> </div>
            <div className="col-lg-4 order-1 order-lg-2">
              <h1 className="weltext">{t('APXTConga4__Welcome_Label')} - {myOrders.FirstName}</h1>
              <p className='app-id-text'>
                {t('Applicant_ID_user_profile_info')} #: {myOrders.Applicant_ID__c}
                <button onClick={handleEditToggle} className="btn btn-link-edit-cgfns">
                  { }
                  <i className="bi bi-pencil-fill pencil-icon-cgfns"></i>
                </button>
              </p>
              <div className="d-flex align-items-center">
                {}
                <div className="position-relative profile-details">
                  {applicantImage && <img src={applicantImage} alt="Applicant" width={160} height={160} />}
                  <input
                    type="file"
                    onChange={handleFileChange}
                    className="form-control-file mt-2"
                    accept="image/*"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                  />
                  <button
                    className="btn upload-btn-cgfns mt-2"
                    onClick={triggerFileInput}
                    disabled={uploading} // Disable the button while uploading
                  >
                    <i className="bi bi-upload"></i>
                    {uploading ? 'Uploading...' : 'Upload Photo'}
                  </button>
                </div>

                <div>
                  <p className="Email-Text">
                    <strong>{t('APXTConga4__Email_Node')}</strong>: {myOrders.Email}</p>
                  <p className="Email-Text">
                    <strong>{t('BMCServiceDesk__Phone')}</strong> :{myOrders.Phone}</p>
                  <div>
                  </div>
                </div>
              </div>
             <div className="photo_alert" style={{ fontSize: '0.8rem' }}>
              {t('Upload_Photo_user_profile_info')}
               <br />
              </div>
              <SFLink path={`/${portal}/s/authorized-representative?contactid=${myOrders.Id}`} className="btn btn-primary ml-2 mt-2" > {t('Authorized_Representative')} </SFLink>             
            </div>
          </div>

          <div className="row mt-4">
  <div className="col-12">
    <h2 className="heading1">{t("Purchased_Orders")}</h2>
    {myPurchasedOrders?.length > 0 && (
      <p><strong>{t('Purchase_Details_app_tracker')}</strong></p>
    )}
    
    {/* Desktop View */}
    <div className="table-responsive d-none d-md-block">
      <table className="table myOrders table-bordered">
        {myPurchasedOrders?.length > 0 && (
          <thead>
            <tr>
              <th>{t('BMCServiceDesk__Order')}</th>
              <th>{t('BMCServiceDesk__ACLogStatus')}</th>
              <th>{t('Order_Date_app_tracker')}</th>
              <th>{t('Expiration_Date')}</th>
              <th>{t('View_Order_Requirements_app_tracker')}</th>
              <th>{t('Additional_Directions')}</th>
            </tr>
          </thead>
        )}
        <tbody>
          {myPurchasedOrders?.length > 0 ? (
            myPurchasedOrders.map((app, index) => (
              <tr key={index}>
                <td width="20%"><OrderColumn app={app} /></td>
                <td width="160px">{app.External_Status__c}</td>
                <td width="150px">{formatDate(app.order_Payment_Date__c)}</td>
                <td width="150px">{formatDate(app.application_expiration_date__c)}</td>
                <td width="20%"><AppStatusTracker app={app} isICDPortal={app.isICDPortal} /></td>
                <td><AdditionalInfoColumn app={app} /></td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">{isICD ? t('ICD_No_purchased_app') : t('No_purchased_app')}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* Mobile View */}
    <div className="d-block d-md-none">
      {myPurchasedOrders?.length > 0 ? (
        myPurchasedOrders.map((app, index) => (
          <div className="order-item" key={index}>
            <div className="order-row">
              <div className="order-header">{t('BMCServiceDesk__Order')}</div>
              <div className="order-detail"><OrderColumn app={app} /></div>
            </div>
            <div className="order-row">
              <div className="order-header">{t('BMCServiceDesk__ACLogStatus')}</div>
              <div className="order-detail">{app.External_Status__c}</div>
            </div>
            <div className="order-row">
              <div className="order-header">{t('Order_Date_app_tracker')}</div>
              <div className="order-detail">{formatDate(app.order_Payment_Date__c)}</div>
            </div>
            <div className="order-row">
              <div className="order-header">{t('Expiration_Date')}</div>
              <div className="order-detail">{formatDate(app.application_expiration_date__c)}</div>
            </div>
            <div className="order-row">
              <div className="order-header">{t('Application_status_tracker')}</div>
              <div className="order-detail"><AppStatusTracker app={app} isICDPortal={app.isICDPortal} /></div>
            </div>
            <div className="order-row">
                        <div className="order-header">{t('Missing_Requirement')}</div>
                        <div className="order-detail">
                          <button className='anchor-button quick-view-link' href="#" onClick={() => handleMissingReqShow(app.Id)} >{t('Missing_Requirement')}</button>
                        </div>
                      </div>
            <div className="order-row">
              <div className="order-header">{t('Additional_Directions')}</div>
              <div className="order-detail"><AdditionalInfoColumn app={app} /></div>
            </div>            
          </div>
        ))
      ) : (
        <div className="order-item">
          <div className="order-detail">{isICD ? t('ICD_No_purchased_app') : t('No_purchased_app')}</div>
        </div>
      )}
    </div>
  </div>
</div>



    
            </div>
        
        <ProgReportSection portal={portal}
                      showProgReportSection={showProgReportSection}
                      currentApp={prsApp}
                      isICDPortal={isICD}
                      showRejectionTextDiv={showRejectionTextDiv}
                      rejectionText={rejectionText}
                      handleClickAccept={handleClickPRSAccept}
                      handleClickShowReason={handleClickPRSShowReason}
                      handleClickAcceptRejection={handleClickPRSAcceptRejection}
                    />
      {/* modal for email and phone edit */}
      <EditModal
        show={editModal}
        handleClose={() => setEditModal(false)}
        tempEmail={tempEmail}
        tempPhone={tempPhone}
        setTempEmail={setTempEmail}
        setTempPhone={setTempPhone}
        handleSave={handleSave}
      />     
      <MissingRequirementsModal
              show={showMissingReqModal}
              handleClose={handleMissingReqClose}
              applicationID={MissingReqAppId}
            /> 
      </AuthenticatedTemplate>
    </>
  );
};

export default HomePage;
